import React from "react";
import {
  getPageSpeedSourceGroups,
  PAGE_SPEED_PROVENANCE,
} from "@/data/pageSpeedGuidance";

export function PageSpeedProvenance({ specialist }: { specialist: string }) {
  const groups = getPageSpeedSourceGroups(specialist);
  const sources = groups.flatMap((group) =>
    PAGE_SPEED_PROVENANCE.sourceGroups[group].links.map((link) => ({
      ...link,
      groupLabel: PAGE_SPEED_PROVENANCE.sourceGroups[group].label,
    })),
  );

  return (
    <div className="page-speed-provenance" aria-label="Page speed guidance provenance">
      <span className="page-speed-provenance__reviewed">
        Guidance reviewed {PAGE_SPEED_PROVENANCE.reviewedDate}
      </span>
      <span className="page-speed-provenance__separator" aria-hidden="true">·</span>
      <span className="page-speed-provenance__sources-label">Sources:</span>
      {sources.map((source) => (
        <a
          key={source.href}
          href={source.href}
          target="_blank"
          rel="noopener noreferrer"
          title={source.groupLabel}
        >
          {source.label}
        </a>
      ))}
    </div>
  );
}